import { render, staticRenderFns } from "./SQuesFiftyTwo.vue?vue&type=template&id=4daaa56a&"
import script from "./SQuesFiftyTwo.vue?vue&type=script&lang=js&"
export * from "./SQuesFiftyTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports